export default (extensionJoints, eventName, value) =>
    extensionJoints.reduce(
        (response, extensionJoint) =>
            Object.assign(
                {
                    [extensionJoint.getName()]: extensionJoint
                        .getExtension()
                        .getEventListener(eventName)(value)
                },
                response
            ),
        {}
    );



// WEBPACK FOOTER //
// ./src/compose/syncMap.js